import { useEffect, useState } from "react";
import { Link } from "react-router-dom";

const BlogBanner = (props) => {
  return (
    <div id="journeyHeadingBlock" className=" oh pr z0 ">
      <div className="container ">
        <div className="sharedHeaderBlockCopy">
          <h1 className="align-content-start heroText">
            {props.headlineLine1}
          </h1>

          {props.author && (
            <p className="writtenBy">
              <span>
                {props.avatarImageURL && (
                  <img
                    className="blogAvatar"
                    src={props.avatarImageURL}
                    alt="{props.author}"
                  />
                )}
              </span>
              Written by <strong>{props.author}</strong>
            </p>
          )}

          <h1 className="align-content-start heroText">
            {props.headlineLine2}
          </h1>
          {/* <p className="banner-subheadline">
            {props.subheadlineLine1} {props.subheadlineLine2}
          </p> */}
          <p className="banner-subheadline"></p>
          {props.hasCTA === "true" && (
            <Link
              to="/get-a-quote"
              className="btn btn-green btn-wider mt-3 mb-2 lufga"
            >
              {props.CTAText}
            </Link>
          )}
          {props.hasScrollCTA === true && (
            <button
              onClick={() => {
                props.scrollCTARef.current.scrollIntoView({
                  behavior: "smooth",
                  block: "center",
                });
              }}
              className="btn btn-green mt-3 btn-wider mb-2 lufga"
            >
              {props.CTAText}
            </button>
          )}
        </div>
      </div>

      <div className="bannerSVG ">
        <svg width="800" height="800" viewBox="0 0 1600 1600">
          <defs>
            <clipPath id="clip-path999">
              <rect
                id="Rectangle_801"
                data-name="Rectangle 801"
                width="1800"
                height="1800"
                transform="translate(1108 100)"
                fill="#fff"
                stroke="#707070"
                strokeWidth="1"
              />
            </clipPath>
            <clipPath id="clip-path-2">
              <rect
                id="Rectangle_728"
                data-name="Rectangle 728"
                width="1480.896"
                height="1583.644"
                fill="#fff"
              />
            </clipPath>
          </defs>
          <g
            id="Mask_Group_33"
            data-name="Mask Group 33"
            transform="translate(-1108 -112.246)"
            clipPath="url(#clip-path999)"
          >
            <g
              id="Group_1620"
              data-name="Group 1620"
              transform="translate(1233.483 206.881)"
              opacity=".2"
            >
              <g
                id="Group_1619"
                data-name="Group 1619"
                transform="translate(0 0)"
                clipPath="url(#clip-path-2)"
              >
                <path
                  id="Path_2003"
                  data-name="Path 2003"
                  d="M1464.091,856.72c-50.96-13.41-88.614-58.756-89.233-114.9.618-56.146,38.272-101.475,89.233-114.884,10.989-2.455,17.531-12.6,16.724-23.506a20.482,20.482,0,0,0-.5-5.048,901.8,901.8,0,0,0-27.043-104.153c-4.052-10.817-16.226-17.582-28.416-14.886-51.39,14.886-108.188-6.765-135.248-55.459a116.234,116.234,0,0,1,18.938-143.215,21.3,21.3,0,0,0,7.229-17.325A23.768,23.768,0,0,0,1309.9,246.7c-22.99-27.06-48.711-51.407-75.754-75.754a22.9,22.9,0,0,0-31.112,1.356A122.537,122.537,0,0,1,1056.956,192.6c-37.894-22.75-59.305-63.718-59.391-105.527A116.112,116.112,0,0,1,1001.5,58.83a21.743,21.743,0,0,0-.154-14.543,22.289,22.289,0,0,0-14.715-15.35A727.592,727.592,0,0,0,883.831.52c-12.173-2.7-24.347,5.426-27.043,16.243-13.53,52.746-60.885,90.623-116.327,90.623-55.459,0-102.8-37.877-116.327-89.284C621.439,5.946,609.248-2.175,597.074.52a681.774,681.774,0,0,0-102.8,28.416c-11.384,3.795-18.046,14.7-15.522,24.965a30.55,30.55,0,0,0,.652,4.928,121.4,121.4,0,0,1,3.949,28.657c-.223,41.672-21.617,82.433-59.408,105.115a122.536,122.536,0,0,1-146.082-20.295,22.877,22.877,0,0,0-31.095-1.356A665.867,665.867,0,0,0,171.017,246.7a23.783,23.783,0,0,0-5.889,16.638,21.354,21.354,0,0,0,7.229,17.325A116.169,116.169,0,0,1,191.3,423.882c-28.4,48.694-83.858,70.346-135.248,55.459-12.174-2.7-24.347,4.069-28.4,14.886C15.474,528.035,7.353,563.2.588,598.38A24.328,24.328,0,0,0,.021,604.2c-.446,10.611,6.078,20.346,16.792,22.733,50.978,13.41,88.614,58.739,89.25,114.884-.635,56.146-38.272,101.492-89.25,114.9C5.842,859.159-.717,869.306.09,880.209a22.418,22.418,0,0,0,.5,5.065,903.66,903.66,0,0,0,27.06,104.153c4.052,10.817,16.226,17.582,28.4,14.869,51.39-14.869,108.205,6.765,135.248,55.459a116.194,116.194,0,0,1-18.939,143.232,21.3,21.3,0,0,0-7.229,17.307,23.852,23.852,0,0,0,5.889,16.655c22.991,27.043,48.694,51.39,75.754,75.737a22.894,22.894,0,0,0,31.095-1.339,122.511,122.511,0,0,1,146.082-20.295c37.911,22.733,59.322,63.7,59.408,105.51a115.178,115.178,0,0,1-3.949,28.245,21.845,21.845,0,0,0,.155,14.543,22.346,22.346,0,0,0,14.715,15.367,728.83,728.83,0,0,0,102.8,28.4c12.174,2.713,24.364-5.408,27.06-16.226a120.188,120.188,0,0,1,116.327-90.623c55.442,0,102.8,37.86,116.327,89.267,2.7,12.173,14.869,20.3,27.043,17.582a681.211,681.211,0,0,0,102.8-28.4c11.4-3.795,18.046-14.715,15.522-24.965a27.313,27.313,0,0,0-.653-4.945,120.386,120.386,0,0,1-3.932-28.657c.223-41.672,21.617-82.433,59.408-105.1a122.49,122.49,0,0,1,146.065,20.295,22.916,22.916,0,0,0,31.112,1.339,668.518,668.518,0,0,0,75.754-75.737,23.837,23.837,0,0,0,5.872-16.655,21.247,21.247,0,0,0-7.229-17.307,116.259,116.259,0,0,1-18.938-143.232c28.416-48.694,83.858-70.328,135.248-55.459,12.191,2.713,24.364-4.052,28.416-14.869,12.173-33.825,20.295-68.989,27.043-104.153a23.568,23.568,0,0,0,.567-5.82c.446-10.611-6.061-20.347-16.792-22.733M1156.353,430.046q8.448,11.2,16.312,22.836a15.35,15.35,0,0,1-9.134,23.471L769.324,571.269a87.979,87.979,0,0,0-61.348,53.5L666.218,731.62a7.649,7.649,0,0,1-14.251,0l-14.8-38.014a38.288,38.288,0,0,1,.24-28.365l35.731-87.206a87.89,87.89,0,0,1,60.112-52.008l407.187-101.543a15.282,15.282,0,0,1,15.916,5.563m-441.1,434.8,74.123-180.989A87.989,87.989,0,0,1,848.6,632.068l356.364-92.89a15.245,15.245,0,0,1,18.011,8.946q6.052,15.118,11.177,30.666a15.131,15.131,0,0,1-10.834,19.831L887.9,681.174a87.988,87.988,0,0,0-60.9,53.4L747.106,938.948a7.653,7.653,0,0,1-14.251-.017l-17.84-45.689a38.21,38.21,0,0,1,.24-28.4m25.206-642.914A517.473,517.473,0,0,1,1077.543,346.2c9.478,8.087,5.58,23.574-6.542,26.442l-410.913,97.3a87.971,87.971,0,0,0-61.658,53.57l-6.61,16.913a7.645,7.645,0,0,1-14.251-.017L489.435,313.942A27.385,27.385,0,0,1,502.33,279.7a517.16,517.16,0,0,1,238.131-57.777m-8,1039.73c-275.751-4.138-502.7-226.988-511.615-502.635a517.289,517.289,0,0,1,99.586-323.414c12.4-16.981,38.512-14.011,46.531,5.409l276.592,670.489a53.564,53.564,0,0,0,49.5,33.121H789a53.551,53.551,0,0,0,49.553-33.241L954.279,828.819a88.02,88.02,0,0,1,59.666-51.888l227.211-57.966a15.335,15.335,0,0,1,19.127,14.595c.052,2.747.069,5.511.069,8.259,0,289.8-237.1,524.2-527.892,519.839"
                  transform="translate(-0.004 0)"
                  fill="#fff"
                />
              </g>
            </g>
          </g>
        </svg>
      </div>
    </div>
  );
};

export default BlogBanner;
